export default {
  colors: {
    black: '#000e1a',
    white: '#fff',
    blue: '#133952',
    navy: '#004175'
  }
}